import { ActionHandler } from "..";
import { loadSubscriptionStatus } from "src/hooks/subscriptionStatus";
import { clinicalPlanIdPrefix, clinicalPlans } from "@utils/plansMapping";
import { setProductSwitchData } from "src/utils/redux/slices/productSwitch";
import getStore from "src/utils/redux/store";
import { queryProductSwitchOffers } from "src/api/productSwitchOffers";

export async function loadAndStoreProductSwitchData() {
  try {
    const [subscriptionStatus, offers] = await Promise.all([
      loadSubscriptionStatus(),
      queryProductSwitchOffers(),
    ]);

    const planId = subscriptionStatus?.planId;

    let currentProductName: string | null = null;
    if (planId) {
      if (planId.startsWith(clinicalPlanIdPrefix.compoundedMicrodose)) {
        currentProductName = clinicalPlans.compoundedMicrodose;
      } else if (planId.startsWith(clinicalPlanIdPrefix.compounded)) {
        currentProductName = clinicalPlans.compounded;
      } else if (
        planId.startsWith(clinicalPlanIdPrefix.compoundedTirzepatide)
      ) {
        currentProductName = clinicalPlans.compoundedTirzepatide;
      }
    }

    getStore().dispatch(setProductSwitchData({ currentProductName, offers }));
  } catch (error) {
    getStore().dispatch(
      setProductSwitchData({ currentProductName: null, offers: [] })
    );
  }
}

export const loadProductSwitchData: ActionHandler = async () => {
  await loadAndStoreProductSwitchData();
};
